import './MenuItem.css';

function MenuItem({ name, description, price }) {
  return (
    <div className="menu-item">
      <div className="menu-item__header">
        <h3 className="menu-item__name">{name}</h3>
        <span className="menu-item__dots"></span>
        <span className="menu-item__price">${price.toFixed(2)}</span>
      </div>
      <p className="menu-item__description">{description}</p>
    </div>
  );
}

export default MenuItem;
